// extracted by mini-css-extract-plugin
module.exports = {"prodImage":"active-product_prodImage__3a3n9","prodName":"active-product_prodName__31j2L","custombadge":"active-product_custombadge__24rv0"};